import { format } from 'owa-localize';
import { makeDeleteRequest } from 'owa-ows-gateway';
import { HttpStatusCode } from 'owa-http-status-codes';

import setErrorCode from '../mutators/setErrorCode';

export async function deleteRequest(deleteUrl: string, email = null): Promise<Response> {
    var errorCode = null;

    if (email) {
        deleteUrl = format(deleteUrl, email);
    }

    await makeDeleteRequest(deleteUrl, undefined, undefined, true)
        .then(response => {
            if (response.status === HttpStatusCode.OK) {
                return null;
            } else if (response.status === HttpStatusCode.BadRequest) {
                return response.json();
            } else {
                const unknownError = {
                    errorCode: '0',
                    message: 'unknown error',
                };

                return unknownError;
            }
        })
        .then(responseData => {
            if (responseData) {
                errorCode = responseData.errorCode;
            }
        });

    setErrorCode(errorCode);

    return errorCode;
}
